export default {
  shopMng: {
    myShop: '我的店铺',
    productPubsub: '商品发布',
    taskPubsub: '任务发布',
    orderMng: '订单管理',
    myAddress: '仓库管理'
  },
  //  我的店铺
  myShop: {
    serialNumber: '序号',
    shopName: '店铺名称',
    shopType: '店铺类型',
    shopLogo: '店铺Logo',
    shopStart: '开店时间',
    shopStatus: '营业状态',
    usual: '正常营业',
    prohibit: '违规禁封',
    operate: '操作',
    inputShopNamePlaceholder: '输入店铺名称',
    selectStatusPlaceholder: '请选择营业状态',
    search: '查询',
    clear: '重置',
    shopInfo: '店铺简介',
    infoChange: '信息变更',
    shopMainPic: '店铺banner',
    brandSelfStore: '品牌自营店铺',

    //  店铺简介
    tel: '手机号',
    people: '联系人',
    address: '联系地址',
    businessLicense: '营业执照',
    tax: '税号'
  },
  //  商品发布
  productPubsub: {
    addProduct: '添加商品',
    picProduct: '商品图片',
    namePro: '商品名称',
    saleNum: '销量',
    tyep: '所属分类',
    status: '审核状态',
    setStatus: '设置状态',
    operate: '操作',
    editPro: '商品编辑',
    viewSpecs: '查看规格',
    repPro: '商品补货',
    notificationPro: '商品通知',
    putOn: '上架',
    videoPro: '商品视频',
    top: '置顶',
    giveaway: '赠品',
    statusUsual: '审核通过',
    noAuth: '待审核',

    //添加商品
    proBrand: '商品品牌',
    typeInput: '分类入口',
    typePro: '商品分类',
    ProductType: '商品类型', // 商品类型 1.5.12 新增
    virtuallyProductType: '虚拟商品类型', // 虚拟商品类型
    ordinaryCommodity: '普通商品', // 普通商品 1.5.12 新增
    PackageCommodity: '套餐商品', // 套餐商品 1.5.12 新增
    virtuallyCommodity: '虚拟商品', // 虚拟商品 1.5.12 新增
    admissionFee: '门票', // 门票
    electronicRoll: '电子劵', // 电子劵
    site: '场地', // 场地 1.5.12 新增
    namePro: '商品名称',
    proSecondTitle: '商品副标题',
    proInfo: '商品介绍',
    computerUnit: '计量单位',
    proKey: '商品关键字',
    nextStep: '下一步 ',
    lastStep: '上一步',
    specificationTemplate: '规格模板',
    add: '增加',
    clickToUpload: '点击上传',
    productParameters: '商品参数',
    refreshTheList: '刷新列表',
    salesInformation: '销售信息',
    internationalBarcode: '国际条码',
    skuCode: 'SKU编码',
    supplyPrice: '供货价',
    suggestedPrice: '建议售价',
    proStock: '商品库存',
    inventoryWarningValue: '库存预警值',
    long: '长（cm）',
    width: '宽（cm）',
    height: '高（cm）',
    grossWeight: '毛重(kg)',
    productCode: '商品编码',
    proMainPic: '商品主图',
    proDetail: '商品详情',
    uploadPic: '上传图片',
    basePolicy: '基本政策',
    fakeOnePayThree: '假一赔三',
    brandAfter: '品牌售后',
    fastDelivery: '快速发货',
    fastRefund: '快速退款',
    chosePolicy: '可选政策',
    proFreeShipping: '商品包邮',
    selectShippingWarehouse: '选择发货仓库',
    deliveryAddress: '发货地址',
    submitProduct: '完成，提交商品',
    address: '地址', // 地址
    longitudeAndLatitudePrompts: '请输入经纬度'
  },
  //  任务发布
  taskPubsub: {
    searchCondition: '筛选搜索',
    taskType: '任务类型',
    search: '查询',
    clear: '重置',
    dataList: '数据列表',
    add: '添加',
    serialNumber: '序号',
    picProduct: '商品图片',
    namePro: '商品名称',
    start: '开始时间',
    end: '结束时间',
    operate: '操作',
    viewDetail: '查看详情',

    //添加任务
    chosePro: '选择商品',
    growthTool: '增长工具',
    skuPic: 'SKU图片',
    skuPara: 'SKU参数',
    priceAdjust: '调价',
    giveawayStock: '赠品库存',
    startTime: '开始日期',
    endTime: '结束日期',
    chooseAProduct: '选择商品，可选择多规格',
    searchSKU: '查询SKU',
    pic: '图片',
    param: '参数',
    salePrice: '销售价格',
    proStock: '商品库存',
    taskStock: '任务库存',
    giveawayChose: '选择赠品'
  },
  //  订单管理
  orderMng: {
    searchCondition: '筛选搜索',
    searchInput: '输入搜索',
    receiver: '收货人',
    submissionTime: '提交时间',
    orderStatus: '订单状态',
    orderType: '订单分类',
    orderSource: '订单来源',
    search: '查询',
    clear: '重置',
    dataList: '数据列表',
    num: '序号',
    orderNum: '订单编号',
    putTime: '提交时间',
    userNum: '用户账号',
    orderMoney: '订单金额',
    payType: '支付方式',
    orderSource: '订单来源',
    operate: '操作',
    reviewOrder: '查看订单',

    //查看订单
    putOrder: '提交订单',
    userPay: '用户付款',
    shopShip: '店铺发货',
    fastDelivery: '快递配送',
    UserReceivesGoods: '用户收货',
    quickServece: '快速服务',
    orderTime: '订单已耗时',
    shopStockUp: '店铺备货中',
    shipDetail: '快递详情',
    quickPro: '立即发货',
    prsentStatus: '当前订单状态',
    editOwerInfo: '修改收货人信息',
    sendMessage: '发送站内信',
    cancelOrder: '取消订单',
    remarkOrder: '备注订单',
    orderInfo: '订单信息',
    orderSku: '订单编号',
    placeAnOrder: '下单时间',
    UserID: '用户ID',
    payType: '支付方式',
    orderSource: '订单来源',
    proPic: '商品图片',
    productName: '商品名称',
    ProductType: '商品类型', // 商品类型 1.5.12 新增
    supplyPrice_: '供货价/件',
    Specification: '规格',
    num: '数量',
    shopDiscount: '店铺优惠',
    Subtotal: '小计',
    logisticsInformation: '物流信息',
    deliveryMethod: '配送方式',
    shipmentNumber: '物流单号',
    sumitTime: '自动确认收货时间',
    orderAvailable: '订单可得优币',
    orderAvailableValue: '订单可得成长值',
    activeInfo: '活动信息',
    payInfo: '支付信息',
    payType: '支付方式',
    payTime: '支付时间',
    supplyPrice: '供货价',
    freight: '运费',
    discount: '优惠',
    installmentServiceFee: '分期服务费',
    tax: '税费',
    integral: '积分',
    totalPayment: '合计支付',
    operatInformation: '操作信息',
    operater: '操作者',
    operatHistory: '操作记录',
    operateTime: '操作时间',
    remark: '备注'
  },
  //  仓库管理
  myAddress: {
    addNewAddress: '新增发货仓库',
    num: '序号',
    addressName: '仓库名称',
    address: '仓库地址',
    manager: '管理人',
    tel: '联系电话',
    operate: '操作',
    updateAddress: '变更仓库地址',

    //添加仓库
    addAgainIfMore: '品牌若存在多个仓库请重新添加',
    whickPlace: '所在地区',
    detailAddress: '详细地址',
    postCode: '邮编',
    usualLogis: '配置常用物流',
    defaultLogis: '默认物流'
  },
  //  开通店铺
  openShop: {
    myBrand: '我的品牌',
    openSelfShop: '开启品牌自营',
    num: '序号',
    brandName: '品牌名称（ID）',
    brandName1: '品牌名称',
    brandLogo: '品牌商标',
    operateCountry: '运营国家',
    operateType: '运营类型',
    brandStatus: '品牌状态',
    operate: '操作',
    brandInfo: '品牌简介',
    inputPlaceBrand: '输入品牌名称',
    waitAuth: '待审核',
    usual: '正常',
    shopLogoNum: '商标注册号',
    brandFromCountry: '品牌归属地',
    ownerBrand: '品牌所有人',
    tel: '联系手机',
    email: '联系邮箱',
    email1: '邮箱',
    evidence: '证明材料'
  },
  //  资产中心
  assetCenter: {
    REType: '收支类型',
    TranCompTime: '交易完成时间',
    num: '序号',
    orderNum: '订单号',
    waterNum: '流水号',
    TrWdAmount: '交易/提现金额',
    deductHandFee: '扣除手续费总额',
    actualDepositDisbursementAmount: '实际入账/出账金额',
    totalAmount: '账户总金额',
    WithdrawalApplicateTime: '提现申请时间',
    WithdrawalNum: '提现单号',
    amountWithdrawn: '可提现金额',
    applicationWithdrawalAmount: '申请提现金额',
    WithdrawalFee: '提现手续费',
    actualAmountReceived: '实际到账金额',
    IDPassportExpirationDate: '身份证/护照有效期',
    CardholderName: '持卡人姓名',
    BankDeposit: '开户银行',
    BankCardNumber: '银行卡卡号',
    BankCardValidityPeriod: '银行卡有效期',
    applicant: '申请人',
    withdrawalStatus: '提现状态',
    actualPaymentAmount: '实际打款金额',
    auditOperators: '审核操作人员',
    processingCompletionTime: '处理完成时间',
    operate: '操作',

    //  新加   6-30
    withdraw: '提现',
    WithdrawableBalance: '可提现余额',
    frozenAmount: '冻结金额',
    bindBankCard: '绑定银行卡',
    revenueExpenditureRecords: '收支记录',
    revenueExpenditureType: '收支类型',
    applicationTime: '申请时间',
    paymentTime: '付款时间',
    orderType: '订单类型',
    orderCompletionTime: '订单完成时间',
    parentOrderNumber: '母订单编号',
    subOrderNumber: '子订单编号',
    afterSalesStatus: '售后状态',
    afterSalesApplicationTime: '售后申请时间',
    afterSalesOrderNumber: '售后单编号'
  },
  //  活动管理
  activeMng: {
    filterSearch: '筛选搜索',
    inputSearch: '输入搜索',
    clear: '重置',
    search: '查询',
    activeName: '活动名称',
    activeStart: '活动开始日期',
    founder: '创建人',
    activeCreate: '活动创建时间',
    activeStatus: '活动状态',
    authStatus: '审核状态',
    activeSecondTitle: '活动副标题',
    listPic: '列表图',
    detailPic: '详情图',
    taskPro: '任务商品',
    levelAward: '关卡奖励',
    activeSecondTitle: '添加活动任务商品',
    choseLevelAward: '选择关卡赠品',
    choseNumAward: '选择排名奖励',
    endNum: '结束名次',
    startNum: '开始名次'
  },
  //  活动审核
  activeAuth: {
    activeList: '活动列表',
    startTime: '开始日期',
    endTime: '结束日期',
    validityPeriod: '活动有效期',
    activeName: '活动名称',
    operateTime: '操作时间',
    productStock: '可用库存',
    activeTaskStock1: '活动任务库存',
    activeTaskStock2: '关卡奖励商品',
    activeTaskStock: '排名大奖',

    brand: '品牌',
    shopNum: '商家编码',
    // shopNum: '店铺编号', 以前是叫店铺编号
    activeEndTime: '活动结束日期',
    activeAuthPeople: '操作人',
    proStatus: '商品状态'
  },
  //  用户列表
  userAuth: {
    inputPlaceUserName: '请输入用户名姓名',
    inputPlaceAnthStatus: '请选择审核状态',
    userName: '姓名',
    pass: '通过',
    reject: '拒绝',

    userList: '用户列表'
  },
  //  商家端字段补充
  merchant: {
    trademarkRights: '商标权限',
    withdrawNum: '提现单号',
    withdrawType: '提现打款方式',
    withdrawOprateTime: '审核操作时间',
    IDCardName: '持卡人姓名',
    IDCardBank: '开卡银行',
    bankNum: '银行账号',
    export: '导出',
    IDname: '身份证/护照姓名',
    IDnum: '身份证/护照号码',
    businessLicenseFront: '上传营业执照（正面）',
    taxFileNumberFront: '税号文件（正面）',
    add: '新增',
    itemNo: '货号',
    taskName: '任务名称',
    shippingSettings: '运费设置',
    freeShipping: '包邮',
    shippingTemplate: '运费模板',
    selectedItems: '已选择的商品',
    selectedGifts: '已选择的赠品',
    selectedPro: '选择商品',
    selectedGifts2: '选择赠品',
    inputProName: '请输入商品名称',
    proBarcode: '商品条码',
    addNewStorehouse: '新增发货仓库',
    cancel: '取 消',
    confirm: '确 定',
    prizeSupplyPrice: '奖品供货价',
    submit: '提交',
    productNumber: '商品编号',
    lengthWidthHeight: '长*宽*高(cm)',
    harvestAddress: '收货地址',
    distributionPackage: '分配包裹',
    shippingMethod: '运送方式',
    logisticsCompanyName: '物流公司名称',
    shippingBillNumber: '发货运单号',
    addPackage: '添加包裹',
    userReceiptInformation: '用户收货信息',
    latestDeliveryLeft: '最晚发货还剩',
    totalCurrentOrder: '当前订单共',
    items: '件商品',
    inputBrandName: '输入品牌名称',
    // 629
    uploadFail10mb: '最多1张，照片支持jpg、png、bmp,每张不超过3MB',
    evidenceFails: '商标受理通知书，商标注册证书，品牌授权书',
    owner1: '个人',
    owner2: '企业',
    TrademarkRights1: '完全持有商标',
    TrademarkRights2: '授权合资公司',
    TrademarkRights3: '授权国代',
    tai: '泰国+66',
    zh: '中国+86',
    en: '美国+1',
    inputTrueInfo: '请确保您填写的信息真实有效',
    inputTrueInfoText: '请填写店铺介绍，这将展示App品牌店铺简介',
    inputInfoTextLookOut: '注意：每月仅限修改一次，请认真填写',
    enterAndCheckTheTaxID: '输入并核对税号',
    categoriesSelectedFitWithinRange: '选择的分类必须符合商标的"商品/服务"范围，否则审核可能不通过',
    pleaseSelect: '请选择',
    pleaseUpload: '请上传',
    areaCode: '区号',
    brandCountry: '品牌国家',
    placeOrigin: '产地',
    home: '国内',
    entrance: '进口',
    SuchPieceBox: '如个、件、箱',
    inputSelectTierDistrict1: '请选择一级行政区',
    inputSelectTierDistrict2: '请选择二级行政区',
    inputSelectTierDistrict3: '请选择三级行政区',
    inputUnitMeasurement: '请输入计量单位',
    inputItemNumber: '请输入商品编号',
    inputFreightTemplate: '请选择运费模板',
    newFreightTemplate: '新建运费模板',
    refreshFreightTemplate: '刷新最新运费模板',
    overtimeFree: '超时免单',
    basicPolicyTitle1: '基本政策为必选项，不可取消',
    basicPolicyTitle2: '针对实际情况选择可选政策',
    basicPolicyTitle3: '超时免单：超过七天到货，直接免单',
    nameConsignee: '收货人姓名/手机号码',
    all: '全部',
    choseTime: '请选择时间',
    merchandiseOrder: '商品订单',
    afterSaleOrder: '售后订单',
    brandMultipleDeliveryWarehousesText: '品牌若存在多个发货仓库请重新添加',
    addNewWarehouseText: '新增发货仓库',
    shopWater: '店铺流水',
    withdrawList: '提现记录',
    traList: '交易记录',

    // --运费模板--7-3
    withdraw: '提现金额',
    goBack: '返回',
    withdrawChoseBank: '选择银行卡',
    couldwidthdraw: '当前账户可提现金额',
    allwidthdraw: '全部提现',
    confirmWidthdraw: '确认提现',
    widthdrawRules: '提现规则',
    widthdrawRules1: '1. 24小时内到账，法定节假日提现自动顺延至工作日',
    // widthdrawRules1: '1.提现打款周期为每周一次，每周五统一打款，如申请时间在打款时间之后，顺延到下个打款周期，请合理安排时间',
    widthdrawRules2:
      '2.因提现为第三方支付公司提供服务，按照服务标准提现需要收取提现金额3%的手续费，现平台给出红利，商家首年入驻免费，提现手续费暂定为0',
    bankMng: '银行卡管理',
    bankMngTitle: '请仔细填写账户信息，如果由于您填写错误导致资金流失，平台概不负责',
    acquiesce: '默认',
    addBank: '新增银行卡',
    idcardType: '证件类型',
    idcardName: '身份证姓名',
    idcardNum: '身份证号码',
    idcardTime: '身份证有效期',
    bankName: '银行名称',
    getVerifyNum: '获取验证码',
    noteCheck: '请注意查收！',
    noteCheck2: '短信验证',
    noteCheckToPhone: '验证短信将发送至您当前账号绑定的手机号',
    suggestRetailPrice: '建议零售价',
    quantitySold: '销售数量',
    orderMoney: '订单供货金额',
    channelSaleServiceFee: '渠道销售服务费',
    ThreeFee: '第三方支付手续费',
    chouponFee: '优惠券抵扣金额',
    activitiFee: '活动奖励服务费',
    saleInFee: '销售入账金额',
    saleAfterCode: '售后单号',
    saleAfterSupplyGoodsFee: '售后退回供货金额',
    AfterSaleRefundChannelSaleServiceFee: '售后退回渠道销售服务费',
    makeAmountDeductedCoupon: '补回优惠券抵扣金额',
    returnFreight: '售后退回运费',
    rewardServiceFeeAfterSaleActivity: '售后退回活动奖励服务费',
    totalAmountReturnedAfterSale: '售后退回总金额',
    settlementAmount: '结算金额',
    totalStockIncludReplenishment: '商品总库存（包含补货）',
    activeLockInventory: '活动锁定库存',
    remainAvailableStock: '剩余可用库存',
    inventoryWarningQuantity: '库存预警数量',
    WarniTime: '预警时间',
    Tips: '提示',
    TipsContent: '交易过程中收取的运费会根据发布商品时选择的运费模板设置来计算，您还可以添加',
    freeShipUnderSpecifieCondition: '指定条件包邮',
    lastEditTime: '最后编辑时间',
    copyOne: '复制模板',
    detail: '详情',
    edit: '编辑',
    del: '删除',
    delBatch: '批量删除',
    transport: '运送方式',
    canShipped: '可运送至',
    firstPiece: '首件',
    addFre: '增加运费',
    defaultFre: '默认运费',
    successor: '续件',
    renew: '续费',
    py: '平邮',
    kd: '快递',
    tgyz: '泰国邮政',
    TemplateName: '模板名称',
    pricingMethod: '计价方式',
    typeNumber: '按件数',
    typeWeight: '按重量',
    typeV: '按体积',
    addOne: '每增加',
    batchSet: '批量设置',
    batchOperate: '批量操作',
    goTo: '运送至',
    shipSpecifiedCity: '为指定地区城市设置运费',
    firstNum: '首件（件）',
    firstFee: '首费（铢）',
    secondNum: '续件（件）',
    secondFee: '续费（铢）',

    // 优惠券
    addCoupon: '添加优惠券',
    CouponsTipContent: '优惠券分为有门槛和无门槛优惠券，主要作用有提升客单价、提高回购率、吸引新老顾客形成购买转化。',
    couponsFace: '优惠券券面信息',
    couponsName: '优惠券名称',
    font60: '最多不超过60个字符',
    font100: '最多不超过100个字符',
    faceVal: '面值',
    useConditions: '使用条件',
    NoLimit: '不限制',
    orderAll: '订单满',
    validityPeriod: '有效期限',
    groundRules: '基本规则',
    TotalAmountIssued: '发放总量',
    CouponRestriction: '领券限制',
    BahtCanUsed: '铢，可使用',
    zhang: '张',
    maximumNumberCoupons: '每个用户自助领券上限，如不选，则默认为1张',
    allProJoin: '全部商品参与',
    NewlyReleasedProductsAdaptRule: '提示：新发布的商品也能适应此规则',
    PartialProJoin: '部分商品参与',
    remove: '移除',
    save: '保存',
    goWhich: '至',
    addCoupon: '新增优惠券',
    BatchCancellation: '批量作废',
    claimRestriction: '领取限制',
    PiecePerson: '张/人',
    stock: '库存',
    Claimed: '已领取',
    haveUsed: '已使用',
    status: '状态',
    proApply: '适用商品',
    proEdit: '修改商品',
    cancellation: '作废',
    chosedPro: '已选商品',
    piece: '件',

    // 优惠券遗漏
    collectionTime: '领取时间',
    useStatus: '使用状态',
    useTime: '使用时间',
    couponType: '优惠券类型',
    receiver: '领取人',
    receiveNum: '领取数量',
    detailAfterSaleOrder: '售后单详情',
    batchOpen: '批量启用',
    enable: '启用',
    couponManagement: '优惠券管理',
    afterSavCoupon: '优惠券保存后，只能对发放总量和领券限制做编辑修改，请谨慎操作',
    receiptRecord: '领用/使用记录',
    voidCoupon: '作废优惠券'
  },
  //  商家端校验信息74
  merchantVerify: {
    pleaseSelectTrademarkRight: '请选择商标权限',
    pleaseSelectCountry: '请选择国家',
    messageFontLong: '长度在 2 到 140 个字符',
    pleaseUploadLogoPicture: '请上传商标图片',
    PleaseEnterTrademarkRegistration: '请输入商标注册号',
    PleaseSelectBrandOwner: '请选择品牌所有人',
    PleaseEnterPhoneNumber: '请输入手机号',
    PleaseEnterEmail: '请输入邮箱',
    PleaseSupportingMaterials: '请添加证明材料',
    PleaseEnterCode: '请输入区号',
    PleaseEnterContactPerson: '请输入联系人',
    PleaseSelectFirstDistrict: '请选择一级行政区',
    PleaseSelectSecondDistrict: '请选择二级行政区',
    PleaseSelectThirdDistrict: '请选择三级行政区',
    PleaseEnterStoreDescription: '请输入店铺简介',
    PleaseUploadBusinessLicense: '请上传营业执照',
    PleaseUploadTaxIDFile: '请上传税号文件',
    PleaseEnteTaxID: '请输入税号',
    PleaseUploadStoreLogo: '请上传店铺商标',
    PleaseSelectProductCategory: '请选择商品分类',
    PleaseSelectCategoryEntry: '请选择分类入口',
    PleaseSelectProperty: '请选择商品类型', //   请选择商品类型 1.5.12新增
    PleaseSelectVirtualGoods: '请选择虚拟商品类型', // 请选择虚拟商品类型
    PleaseEnterProductName: '请输入商品名称',
    PleaseEnterUnitMeasurement: '请输入计量单位',
    PleaseEnterProductSubtitle: '请输入商品副标题',
    PleaseEnterSite: '请输入地址',
    PleaseUploadProductMasterMap: '请上传商品主图',
    PleaseEnterProductCode: '请输入商品编码',
    PleaseEnterSalesInformation: '请输入销售信息',
    UploadProductDetailsMap: '上传商品详情图',
    messageFontLong2140: '长度在 2 到 140 个字符',
    PleaseEnterPriceItem: '请输入商品售价',
    PleaseSelectProductBrand: '请选择商品品牌',
    PleaseEnterProductDescription: '请输入商品介绍',
    fieldRequired: '该项为必填项',
    PleaseEnterTaskName: '请输入任务名称',
    PleaseEnterStartDate: '请输入开始日期',
    PleaseEnterEndDate: '请输入结束日期',
    RealNameAuthenticationInformation: '实名认证信息',
    RealNameAuthentication: '实名认证',
    bankCard: '银行卡',
    confirmInfo: '确认信息',
    activityPro: '活动商品',
    logisticsCompany: '物流公司',
    logisticsCompanyCode: '物流公司Code',
    logisticsCompanyLogo: '物流公司Logo',

    hour: '时',
    min: '分',
    second: '秒',
    salesRevenue: '销售收入',
    submitApplication: '提交申请',
    LookOnMove: '移动端详情',
    PleaseSelectDocumentType: '请选择证件类型',
    IdentificationCard: '身份证',
    passport: '护照',
    ChannelSalesServiceFee: '渠道销售服务费',
    ThirdPaymentCommission: '第三方支付手续费',
    AmountDeductedMerchantCoupon: '商家优惠券抵扣金额',
    PlatformCouponDiscountAmount: '平台优惠券优惠金额',
    QuantityAfterSaleOrder: '售后单数量',
    AmounMerchantCoupon: '补回商家优惠券抵扣金额',
    AmountPlatformCouponReturnedSale: '售后退回平台优惠券优惠金额',
    PassportName: '护照姓名',
    PassportNumber: '护照号码',
    PassportValidityPeriod: '护照有效期',
    SelectDate: '选择日期',
    close: '关 闭',
    BrandSelfOperatStore: '品牌自营业店铺',
    AfterSaleReceived: '售后待收货',
    refunded: '待退款',
    AfterSaleCompletion: '售后完结',
    due: '待付款',
    sendOutGoods: '发货', // 发货  1.5.12新增
    GoodsWaitSent: '待发货',
    shipped: '已发货',
    completed: '已完成',
    TargetClosed: '已关闭',
    InvalidOrder: '无效订单',
    H5Order: 'H5订单',
    RegularOrder: '正常订单',
    AppOrder: 'APP订单',
    TaskDistributOrder: '任务分润订单',
    TaskRewardOrder: '任务奖励订单',
    RankingGrandPrizeAwardsOrder: '排名大奖奖励订单',
    chosePlace: '选择地区',
    setShip: '设置包邮条件',
    WithinThe: '内'
  },
  //  运营端字段补充74
  operationEnd: {
    userList: '用户列表',
    brandList: '品牌列表',
    brandPlaceholder: '请输入品牌名称',
    //7-6
    BrandEntry: '品牌录入',
    ActivateStore: '激活店铺',
    DeterministicClassification: '确定分类',
    NotYetStarted: '未开始',
    UnderWay: '进行中',
    AlreadyEnded: '已结束',
    AuditRejection: '审核拒绝',
    audited: '已审核',
    CorporateTransfer: '公司转账',
    DirectWithdrawal: '直接提现',
    InApplication: '申请中',
    SuccessfulWithdrawal: '提现成功',
    WithdrawalFailure: '提现失败',
    BrandMerchant: '品牌商家',
    WaitingClaimed: '待领取',
    baht: '铢',
    baht1: '铢，可使用',
    ImportCertificateName: '导入兑换券名称',
    InventoryQuantity: '库存数量',
    HaveImported: '已导入',
    a: '个',
    code: '券码',
    IssueStatus: '发放状态',
    CertificateValidityPeriod: '兑换券有效期',
    ImportCode: '导入券码',
    CouponStatus: '优惠券状态',
    RedeemPrizeVouchers: '兑换奖品/券',
    ExchangeType: '兑换类型',
    NameExchange: '兑换品名称',
    shop: '商家',
    PicExchange: '兑换品主图',
    PrizeValue: '奖品价值',
    PurchasePrice: '采购价',
    RedeemPullNewValue: '兑换拉新用户值',
    PerPersonLimit: '每人限兑',
    ExchangeSpecification: '兑换细则描述',
    CopyThe: '份',
    PositiveMaximumValue9999: '只能填写正整数，不超过9999',
    AddEdit: '添加/编辑',
    ExchangeCodeManagement: '兑换券券码管理',
    CreationTime: '创建时间',
    AfterPurchaseVoucher: '可到店消费的兑换券购买成功后，通过此模块导入，达人兑换成功后，系统根据规则随机发送券码',
    NameCoupon: '兑换券名称',
    VoucherBillNumber: '兑换券券码导入单号',
    AddRedemptionCouponCode: '添加兑换券券码',
    CouponCodeStart: '兑换券起始时间',
    TimeVoucher: '兑换券结束时间',
    DerivedCode: '导出券码',
    AddPrizesVouchers: '添加兑换奖品/券',
    ShelfTime: '上架时间',
    NameExchange: '兑换品名称',
    validityPeriodCoupon: '兑换券有效期限',
    PullUserValue: '拉新用户值',
    ConversionStartTime: '兑换开始时间',
    ConversionEndTime: '兑换结束时间',
    ExchangeStatus: '兑换品状态',
    GiftExchangeManagement: '兑换礼品管理',
    ReleasePrizesExchange: '发布达人领取的实物奖品和兑换券，发布成功后，达人在APP才能兑换相应奖品及兑换券',
    replenishment: '补货',
    delist: '下架',
    QuantityPaid: '已兑数量',
    AllConverters: '所有兑换品',
    fillDeliveryAddress: '待填写收货地址',
    received: '已收货',
    ExchangeOrderNumber: '兑换单号',
    ExchangeInformation: '兑换品信息',
    ConversionQuantity: '兑换数量',
    TotalInventory: '总库存',
    ConvertedAmount: '已兑换数',
    ConversionTime: '兑换时间',
    PrizeStatus: '奖品状态',
    TalentAccount: '达人账号',
    ReceivingPhoneNumber: '收货手机号',
    addressProvinceCityDistrict: '收货地址：省-市-区',
    MarkedDelivery: '标记发货',
    ModifyShipAddress: '修改收货地址',
    Guan: '关卡',
    Guan1: '关卡1',
    Guan2: '关卡2',
    //  7-10
    tipsCreateBrandSelfStore: '请正确填写相关信息，我们将在3个工作日内完成审核',
    confirm: '确定',
    concel: '取消',
    ValidUntil: '有效期限至',
    actualAmountReceived: '实际打款到账金额',
    DetailsCurrentAccountFunds: '当前账户资金详情',
    ConfirmPayment: '确认付款',
    rejectPayment: '拒绝付款',
    PleaseEnterFeedback: '请输入反馈信息',
    AdditiveLogisticsCompany: '添加物流公司',
    Claimed: '已领完',
    CashCoupon: '代金券',
    PlatformCoupon: '平台优惠券',
    expired: '已过期',
    cancelled: '已作废',
    PhysicalPrize: '实物奖品',
    certificate: '兑换券',
    WaitingUsed: '待使用',
    invitationCode1: '添加邀请码',
    InvitationCodeType: '邀请码类型',
    InvitationCodeName: '邀请码名称',
    InvitationCode: '邀请码',
    QuantityIssued: '发放数量',
    DailyLimit: '每天限兑',
    maxLimit60: '最多不超过60字符',
    number4: '数字，只能填写4位数字',
    choseTime: '选择日期时间',
    RedEnvelope: '红包闯关',
    OpenBeta: '公测',
    FollowTime: '跟进时间',
    BrandLocation: '品牌所属地',
    FollowPeople: '跟进人',
    WhetherFollow: '是否跟进',
    ContactName: '联系人姓名',
    ContactNumber: '联系人电话',
    BrandOfficialWebsite: '品牌官网',
    follow: '跟进',
    // 7-11
    PleaseRequiredFieldsCarefully: '请认真填写必填项',
    sort: '分类',
    SupplyChainAlliance: '供应链联盟',
    BrandSelfSupport: '品牌自营',
    skuCode1: 'SKU编号',
    skuStock: 'SKU库存',
    CurrentStock: '当前库存',
    DeleteOrder: '删除订单',
    signed: '已签收',
    PayInstallments: '分期付',
    nonPayment: '未支付',
    BankcardPayment: '银行卡支付',
    ThirdPayment: '第三方支付',
    Balancepayment: '余额付',
    UploadVideo: '上传视频',
    ScreeningCondition: '筛选条件',
    ServiceOrderNumber: '服务单号',
    ApplicationStatus: '申请状态',
    ProcessingTime: '处理时间',
    ProcessingState: '处理状态',
    operator: '操作人员',
    // 7 -12
    OrdinaryTask: '普通任务',
    activeTask: '活动任务',
    BasicInformation: '基本信息',
    SalesAllocation: '销售配置',
    ServiceConfiguration: '服务配置',
    Search: '搜索',
    completedAdd: '完成添加',
    RefreshingSkuList: '刷新列表将导致sku信息重新生成，是否要刷新',
    product: '商品',
    productTime: '任务时间',
    inputPlacer: '输入',
    priceMoney: '价格',
    day: '天',
    activeSecondTip: '活动副标题',
    RankingReward: '排名奖励',
    SelectedRankRewards: '已选择的排名奖励',
    SelectRankRewardItems: '选择排名奖励商品',
    ensureNormalDisplay: '为确保正常显示，建议列表尺寸为',
    PleaseSuccessUploaded: '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！',
    zhang1: '1张',
    zhang2: '2张',
    zhang3: '3张',
    zhang4: '4张',
    zhang5: '5张',
    zhang6: '6张',
    zhang7: '7张',
    zhang8: '8张',
    zhang9: '9张',
    zhang10: '10张',
    NotSubmitted: '未提交',
    selfSupport: '自营',
    article: '条',
    KillOrder: '秒杀订单',
    Guan3: '关卡3',

    // 7-17
    PleaseEnterNameImportCoupon: '请输入导入兑换券名称',
    FillNameMerchantOffersExchangeItem: '填写提供兑换商品的商家名称',
    AfterSalePendReview: '售后待审核',
    AfterSaleReceiving: '售后收货',
    SubjectRefundAfterSale: '售后待退款',
    AfterSaleClosing: '售后关闭',
    examine: '审核',
    Declined: '已拒绝',
    paid: '已付款',
    createNow: '立即创建',
    RechargeAccountBalance: '给公测用户账户余额充值',
    InvitationCodeDuration: '邀请码期限',
    InvitationCodeStatus: '邀请码状态',
    noFollowUp: '未跟进',
    HaveFollowed: '已跟进',
    EventRewardServiceSetting: '活动奖励服务费设置',
    MerchantSupplyAmount: '商家供货金额的',
    RewardRatioSystemDefaults: '如果普通任务奖励比例为空，系统默认为',
    OrderSetup: '订单设置',
    SystemAutomaticallyCloseOrder: '分钟内不付款系统将自动关闭订单。如果生效时间为空，系统默认为15分钟',
    AfterMakingOrder: '下单后',
    OrderExpiratTime: '订单失效时间',
    CouponInformat: '优惠券信息',
    TipAfterOpenUserReturns: '提示：开启后，用户退货后退还已使用的优惠券；关闭后，用户下单使用的优惠券不予退还。系统默认为开启状态',
    QuantityPurchasePerItem: '每个商品单次购买数量',
    NotMoreThan: '不超过',
    SinglePurchaseQuantityEachItemEmptySystemDefaults10: '如果每个商品单次购买数量为空，系统默认为10个',
    VoucherUsageRules: '代金券使用规则',
    AfterClaiming: '领取后',
    ValidDefaultValue3Days: '天内有效。如果失效时间为空，系统默认为3天',
    VoucherUseConditions: '代金券使用条件',
    ValueVoucher: '代金券面额',
    BahtOrderAmountFull: '铢， 订单金额满',
    BahtOrderAmountFull2: '铢可用',
    AdditionalRule: '增加规则',
    MaximumCanAdded: '最多可添加8个',
    // 7-18
    NormalQuestReward: '普通任务奖励',
    ActivityLevelReward: '活动关卡奖励',
    activityLevelRewardRatioEmpty: '如果活动关卡奖励比例为空，系统默认为',
    RankingAwards: '排名大奖奖励',
    PrizeRewardRatioEmptySystemDefaults: '如果排名大奖奖励比例为空，系统默认为',
    WithdrawalFeeSetting: '提现手续费设置',
    On: '开启',
    Off: '关闭',
    TipsWithdraw:
      '（提示：开启后，商家提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，商家提现时不扣除手续费，到账金额=提现金额。系统默认为关闭状态；开启状态，如果提现手续费为空，系统默认手续费为3%）',
    UserWithdrawalFee: '用户提现手续费:',
    TipsWithdraw2:
      '（提示：开启后，用户提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，用户提现时不扣除手续费，到账金额=提现金额。系统默认为开启状态，如果提现手续费为空，系统默认手续费为3%）',
    RedEnvelopeCrossTaskSet: '红包闯关任务设置',
    ValidityTorrentUserQualification: '种子用户资格有效期',
    redPackageTips: '如果种子用户资格有效期为空，系统默认为7天。逾期资格失效，不再获得闯关资格',
    redEntryQualificatValid: '红包闯关资格有效期',
    month: '月',
    year: '年',
    redPackageTips2: '如果闯关资格有效期为空，系统默认为90天。逾期资格失效，不再获得红包奖励',
    RedActivityLevelSettings: '红包闯关活动关卡设置',
    BonusAmount: '奖励红包金额',
    THB: '铢',
    if: '如果',
    redAmountEmptySystemDefaults: '奖励红包金额为空，系统默认为',
    crosredEnvelopeLevelSet: '红包闯关红包层级设置',
    InviteUsersFull: '邀请新用户满',
    redEnvelopeRewardPlatformServiceSingleItem: '每个红包奖励=单个商品的平台服务费',
    // 7-20
    CashedOut: '已兑完',
    batchAuth: '批量审核',
    TaskActivityStatisticsPeriod: '任务/活动统计期:',
    TaskActivityDue: '任务/活动逾期:',
    TaskActivityStatisticsPeriodEnd: '任务/活动结束时期后，统计期为',
    TaskActivityStatisticsPeriOverdue: '任务/活动结束时期后，领奖逾期为',
    MissionActivityRewardPeriod7: '天，如果任务/活动统计期为空，系统默认为7天',
    MissionActivityRewardPeriod8: '天，如果任务/活动领奖逾期时间为空，系统默认为8天',
    awardTimeSet: '领奖时间设置'
  },
  //  7.26号后添加的提示语
  supplementaryPrompt: {
    pleaseAddOne: '请至少添加一个分类入口！！',
    pleaseAddLast: '请先填写完上个分类入口',
    pleaseAddLevelNotNull: '分类不能为空，请认真填写分类!',
    ClassificationNotRepeated: '分类不能重复！',
    PleaseEnterFullAddress: '请输入详细地址',
    PleaseSelectRegion: '请选择所在地区',
    PleaseEnterPostalCode: '请输入邮编',
    PleaseEnterAdministratorName: '请输入管理人名称',
    PleaseEnterContactNumber: '请输入联系电话',
    PleaseEnterWarehouseName: '请输入仓库名称',
    VideoUploadedSuccessfully: '视频上传成功！',
    PleaseSelectOperationType: '请选择操作类型',
    PleaseSelectProductWantOperate: '请选择要操作的商品',
    WhetherPerformBatchOperation: '是否要进行该批量操作?',
    WhetherModifyIt: '是否要进行修改?',
    SkuInformationAvailable: '暂无sku信息',
    ModifiedSuccessfully: '修改成功！',
    OrderShipSuccessfully: '订单发货成功！',
    PleaseChecKItemsAssignPackages: '请勾选需要分配包裹的商品!',
    WarmReminder: '温馨提示',
    ValidityPeriod: '您的证件有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！',
    ValidityPeriod1: '您的银行卡有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！',
    PleaseSelectBankCard: '请选择银行卡！！',
    WithdrawalSubmitSuccessfully: '提现申请提交成功！',
    BankCardBindSuccessful: '银行卡绑定成功！',
    PleaseFillBankName: '请填写银行名称',
    PleaseFillCardHolderName: '请填写持卡人姓名',
    PleaseFillName: '请填写姓名',
    BankAccount25Digits: '银行账号需小于25位数！',
    PleaseFillBankAccountNumberOnly: '请填写银行账号且只能为数字！',
    PleaseOnlyNumbers: '请填写银行账号且只能为数字！',
    your: '您的',
    validityPeriodAboutExpire: '有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！',
    CancelCouponWillCancelled: '作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废？',
    SuccessfulCancellation: '成功作废！',
    PleaseSelectContentFirstBatchOperation: '请先选中内容，再做批量操作！',
    CancelCouponsBatches: '批量作废优惠券，未领取的优惠券会作废，不能继续领取，是否批量作废？',
    editSuccess: '编辑成功！',
    GoodsEditSuccessfully: '修改商品成功！',
    CouponValidityPeriod: '优惠券有效期',
    PleaseEnterTotalAmountIssued: '请输入发放总量',
    PleaseCouponValidityPeriod: '请输入优惠券有效期',
    EnabledSuccessfully: '启用成功！',
    InvalidDataEnabledSuccessfully: '已作废的数据启用成功！已过期的数据启用时，需要更新优惠券的有效期限后，才能启用！',
    DoDelCouponsBulk: '是否批量删除优惠券？',
    //  7-28
    processed: '待处理',
    ReturningGoods: '退货中',
    GiveawayStockSmallerAvailableStock: '赠品库存要小于可用库存！',
    PleaseFillGiftInventory: '请填写赠品库存！',
    endDateGreaterStartDate: '结束日期要大于开始日期！',
    endDate7OlderStartDate: '结束日期不能大于开始日期超过7天！',
    PleaseSelectProduct: '请选择商品！',
    PleaseFillInventory: '请填写商品库存！',
    taskInventorySmallerAvailableInventory: '任务库存要小于可用库存！',
    ActivityAudit: '活动审核',
    ConvertibilityPeriod: '可兑换期限',
    PleaseEnterExchangeVoucher: '请输入兑换品/兑换券名称',
    PleaseEnterMerchant: '请输入商家',
    PleaseUploadExchangeCouponMasterChart: '请上传兑换品/兑换券主图',
    PleaseEnterPrizeVoucher: '请输入奖品/兑换券价值',
    PleaseEnterPurchasePrice: '请输入采购价',
    PleaseSelectCoupon: '请选择兑换券',
    PleaseEnterNewUserValueRedemption: '请输入兑换拉新用户值',
    PleaseEnterInventoryQuantity: '请输入兑换拉新用户值',
    PleaseFillExchangeDescription: '请填写兑换细则描述',
    PleaseFillStartDate: '请填写开始日期',
    PleaseFillEndDate: '请填写结束日期',
    PrizeDeliveryManagement: '奖品发货管理',
    PrizeDeliveryManagementTips: '奖品发货管理，实物奖品和兑换券奖品在达人兑换后，会自动发放到达人奖品账户中',
    ConversionTime: '兑换时间',
    ConsigneeArea: '收货人区域',
    ExchangeOrderNumber: '兑换单号',
    remaining: '还剩',
    TimeOut: '已超时',
    SetInventory: '设定库存',
    QueryResult: '查询结果',
    ActiveTime: '活动时间',
    IncentiveStock: '奖励库存',
    PrizeInventory: '大奖库存',
    AddBankCard: '添加银行卡',
    amountDeductedPlatformCoupon: '平台优惠券抵扣金额',
    ReimburseAmountMerchantCoupon: '补回商家优惠券抵扣金额',
    ConfirmShip: '确认并发货',
    EditWaybill: '编辑运单',
    ConfirmDelivery: '确认发货',
    parcel: '包裹',
    hierarchy: '层级',
    hierarchy1: '层级1',
    hierarchy2: '层级2',
    hierarchy3: '层级3',

    //  8-1
    AddedLevelCategoryEntry1: '新增一级分类入口',
    PleaseEnterFirstLevelCategoryEntryName: '请输入一级分类入口名称',
    FirstClassClassificatEntry: '一级分类入口',
    FirstClassClassificatEntry2: '二级分类入口',
    FirstClassClassificatEntry2Num: '二级分类入口数量',
    reveal: '显示',
    sort: '排序',
    NewSecondaryClassificate: '新增二级分类',
    NewFirstClassificatCommodities: '新增商品一级分类',
    PleaseEnterProductCategoryName: '请输入商品一级分类名称',
    PrimaryClassificatCommodities: '商品一级分类',
    SecondaryClassificatCommodities: '商品二级分类',
    SubordinateQuantity: '下级数量',
    NewSecondaryClassificatCommodity: '新增商品二级分类',
    EnterFirstClassNameProduct: '输入商品一级分类名称',
    view: '查看',
    ClassificationName: '分类名称',
    verify: '确认',
    PayAttentPlatformClassificatRule: '注意平台分类规则',
    UpperCategory: '上级分类：',
    EditSpecification: '编辑规格',
    PleaseEnterInvitationCodeName: '请输入邀请码名称',
    PleaseSelectInvitaCodeType: '请选择邀请码类型',
    PleaseEnterInvitatCode: '请输入邀请码',
    OnlyDigitsCanEntered4: '只能填写4位数字',
    PleaseEnterPrizeValue: '请输入奖品价值',
    UpDigits6: '最多6位数',
    PleaseEnterReleaseQuantity: '请输入发放数量',
    PleaseEnterStartDate: '请输入开始日期',
    PleaseEndDate: '请输入结束日期',
    CreatedSuccessfully: '创建成功！',
    lengthLessCharacters60: '长度小于60字符',
    PleaseSelectCouponValidityPeriod: '请选择兑换券有效期',
    RemovedSuccessfully: '移除成功！',
    unissued: '未发放',
    WaitingUsed: '待使用',
    // 8-4
    RedEnvelopeValueThreeLevels: '红包闯关资格三关总价值',
    IndividualShop: '个人店铺',
    input: '输入',
    CorrespondingGoods: '对应商品',
    BarCode: '条码',

    // 8-7新
    deliveryModeExpressTemplate: '运送方式下所有快递模板，默认运费模板设置字段必填！',
    EditingSuccess: '编辑成功！！',
    CreatedSuccessfully: '创建成功！',
    PleaseFillImportCountryCarefully: '请认真填写进口国家！',
    PleaseRegionsOriginCarefully: '请认真填写产地的三级行政区！',
    PleaseRefreshPageSelectStoreAgain: '请刷新页面重新选择店铺！',
    PanningPrice: '淘金价',
    PlatformPrice: '平台价格',
    PlatformProfit: '平台利润',
    TalentProfit: '达人利润',
    ViewShipTemplateDetails: '查看运费模板详情',
    propertyValueCannotEmpty: '属性值不能为空',
    PleaseParametersSpecificaTemplate: '请先在规格模板中填写参数！',
    PleaseSelectShipTemplate: '请选择运费模板！',
    specificationTemplateSaleInformat: '请认真填写规格模板和销售信息！！',
    PleaseFillSKUCode: '请认真填写SKU编码',
    PleaseFilSupplyPrice: '请认真填写供货价',
    PleaseFillSuggestedPrice: '请认真填写建议售价',
    PleaseFillPrice: '请认真填写淘金价',
    goldRushPriceGreaterSupplyPrice: '淘金价应大于供货价',
    PleaseFillInventory: '请认真填写商品库存',
    PleaseFillProductLength: '请认真填写商品长度',
    PleaseFillProductWidth: '请认真填写商品宽度',
    PleaseFillProductHeight: '请认真填写商品高度',
    PleaseFillGrossWeight: '请认真填写商品毛重',
    WhetherAuditProduct: '是否要审核该产品',
    SubmitSuccess: '提交成功',
    WhetherSubmitProduct: '是否要提交该产品',
    FillNameMerchantOffers: '填写提供兑换商品的商家名称',
    ExchangeLOGO: '兑换品LOGO',
    MasterChartRedemptionNotes: '兑换券主图',
    Maximum1Photo1M: '最多1张，照片支持格式jpg，png，bmp,每张不超过3MB',
    Maximum4Photo1M: '最多4张，照片支持格式jpg，png，bmp,每张不超过3MB',
    AddSuccessful: '添加成功',
    PleaseSelectProductFirst: '请先选择商品',
    CancelUnclaimedCouponWhetherCancel: '作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废',
    CodeTypeOpenTestPrizeMandatory: '邀请码类型为公测时，奖品价值为必填项！！',
    DailyLimitGreaterThanAmountIssued: '每天限兑不能大于发放总量！',
    PleaseEnterNumber: '请输入数字',
    withdrawalAmountWithdrawalAmount: '提现金额不能超过可提现金额！！',
    ShippingTime: '发货时间',
    ReceiptTime: '收货时间',
    // 8-9
    withdrawalAmountCannotbe0: '提现金额不能为0！',
    PleaseEnterAdministratorName: '请输入管理人名称',
    PleaseEnterLogisticsCompanyName: '请选择物流公司名称',
    NoMoreThan3Packages: '包裹不能超过3个',
    ShippingWaybillNumberEmpty: '发货运单号不能为空！！',
    DeleteItPleaseExerciseCaution: '确定要删除吗？请谨慎操作！',
    SuccessfullyDelete: '成功删除!',
    PleaseFillOrderHowManyBahtUsed: '请填写订单满多少铢可使用！',
    AddCouponSuccessfully: '添加优惠券成功！！',
    ImportSuccessfully: '导入成功',
    inventoryNotbe0: '库存数量不能为0！',
    PleaseSelectActiveArea: '请选择活动区域',
    SelectCoupon: '选择兑换券',
    CouponLOGO: '兑换券LOGO',
    couponcodeGroupAddedCouponCodeManagement: '选择【兑换券券码管理】中添加的兑换券券码组',
    valueVoucher: '兑换券价值',
    PleaseEnterInteger: '请输入整数!',
    No4MainImages: '主图不能超过4张!',
    SaveSuccessfully: '保存成功!',
    CurrentDeliveryAddress: '当前收货地址',
    ExchangeGoodsReplenishment: '兑换品补货',
    ConfirmRedeemPrizeShelf: '确定将此兑换奖品上架',
    stockPleaseRestockContinuShelves: '库存不足，请先补货再继续上架！',
    SuccessShelves: '上架成功！',
    ConfirmRedemptionPrizeOffShelf: '确定将此兑换奖品下架',
    RemovedSuccessful: '下架成功!',
    ReplenishmentSuccess: '补货成功!',
    ConfirmDelivery: '确定发货',
    TrackingNumber: '快递单号',
    PleaseFillLogisticsCompanyName: '请填写物流公司名称!',
    deleteConverterWhetherBatchDelete: '批量删除兑换品，是否批量删除!',
    BatchDeletionSucceeded: '批量删除成功!',
    DeliverySuccess: '发货成功!',
    PhysicalPrizeInformat: '实物奖品信息',
    value: '价值',
    expire: '到期',
    HaveAlreadyBeen: '已在',
    DeliverGoods: '发货',
    ReceiveGoods: '收货',
    validity: '有效期',
    TotalConsumptionUserValues: '共消耗拉新用户值',
    full: '满',
    available: '可用',
    // 8-14
    PartialGoods: '部分商品',
    AllGoods: '全部商品',
    TobeListed: '待上架',
    AlreadyListed: '已上架',
    NoLongerAvailable: '已下架',
    RealNameAudit: '实名审核',
    PleaseConfirmAuthenticationUserMatchesIDInformation: '请确认实名认证用户信息与证件信息匹配',
    UserData: '用户资料',
    RealName: '真实姓名',
    RegisteredMobilePhone: '注册手机',
    // 8-17
    ChangeProductHasCreatedTask: '该商品已经创建了任务，任务有效期保持一致，不需要再手动设置',
    ConfirmTemplateDeletion: '确认删除模板？',
    CopyTemplateSuccessful: '复制模板成功！！',
    wholeCountry: '全国',
    ExceptDesignatedAreas: '除指定地区外，其余地区的运费采用“默认运费”',
    DefaultTemplate: '默认模板',
    CancelBatch: '取消批量',
    FreePostageBaht: '铢包邮',
    // 8-18
    StoreAudit: '店铺审核',
    ShopInformation: '店铺信息',
    PleaseStoreBrandBusinessInformation: '请确认店铺品牌及经营信息',
    BrandInformation: '品牌信息',
    LevelReward: '关卡奖励',
    // 8-21
    GrowthMissionsOnlySelect3SPUs: '普通任务的增长工具最多只能选择3个spu！！',
    QuestOnly3SpuItemsPerLevel: '任务商品每关只能有1-3个spu商品！！',
    RankingRewardsUpTo5SKUs: '排名奖励最多5个sku！！',
    ActivityLevelRewardsUpTo3SPUs: '活动关卡奖励最多3个spu！！',
    NormalQuestItemsOnlyAddOneSpu: '普通任务商品最多只能添加一个spu！',
    AddUser: '添加用户',
    Type: '类型',
    AccountNumber: '账号：',
    AccountNumber1: '账号',
    Name: '姓名：',
    Name1: '姓名',
    email: '邮箱：',
    password: '密码：',
    remark: '备注：',
    WhetherEnable: '是否启用',
    merchant: '商家',
    Administrator: '管理员',
    AddTime: '添加时间',
    LastLogin: '最后登录',
    AssignRoles: '分配角色',
    yes: '是',
    no: '否',
    PleaseFillAccountNumber: '请填写帐号',
    PleaseFillAccountName: '请填写姓名',
    PleaseFillAccountEmail: '请填写邮箱',
    PleaseFillAccountPassword: '请填写密码',
    searchView: '查询搜索',
    RoleName: '角色名称',
    Description: '描述',
    UserNumber: '用户数',
    AllocateResources: '分配资源',
    DistributionMenu: '分配菜单',
    WhetherSubmitData: '是否提交数据',
    specialA: '件',
    // 822
    EditUser: '编辑用户',
    PleaseLeast1ItemPerLevel: '每关请至少设置1个任务商品！',
    PleaseLeastTwoLevels: '请至少设置两关！',
    ServiceOrderNumber: '服务单号',
    MenuName: '菜单名称',
    MenuProgression: '菜单级数',
    FrontEndName: '前端名称',
    FrontEndIcon: '前端图标',
    ShoworNot: '是否显示',
    sort: '排序',
    Settings: '设置',
    ViewSubordinates: '查看下级',
    UpperMenu: '上级菜单：',
    ResourceName: '资源名称',
    ResourcePath: '资源路径',
    ResourceClassification: '资源分类',
    PleaseSelectMenu: '请选择菜单',
    clear: '清空',
    // 830
    LabelOption: '标签选项',
    EditSwitchPricingMethod: '编辑状态不可切换计价方式！',
    EditSwitchPricingMethod2: '切换计价方式后，所设置当前模板的运输信息将被清空，确定继续么？',
    weightChose: '重量',
    WeightAmountChose: '重量+金额',
    AmountChose: '金额',
    pieceChose: '件数',
    pieceAmountChose: '件数+金额',

    // 9-8
    OperationalEntry: '运营登录',
    entry: '登录',
    ByContinuReadAgree: '继续即表示您已阅读并同意',
    MXCOMEWord: '《MXCOME商家服务协议与隐私政策》',
    PleaseSelectLoginShop: '请选择登录店铺'
  },
  //  1.5.5 调价
  adjustPrice: {
    onSale: '在售中',
    soldOut: '已售罄',
    cumulativeSales: '累计销量',
    shelfStatus: '上架状态',
    FreeOrNot: '是否赠品',
    ReleaseGoods: '发布商品',
    SupplyPriceAdjustment: '供货价调价',
    ShelfBulk: '批量上架',
    BatchRemoval: '批量下架',
    notSet: '未设置',
    ModifyPrice: '修改价格',
    totalSalesVolume: '总销量',
    video: '视频',
    review: '重新审核',
    supplyPriceAdjustRequestForm: '供货价调价申请单',
    originalSupplyPrice: '原供货价',
    currentSupplyPrice: '现供货价',
    EffectiveDate: '生效日期',
    ProductID: '商品ID',
    GoldRushPriceAdjust: '淘金价调价',
    commodityInformation: '商品信息',
    shop: '店铺',
    product: '商品',
    giveaway: '赠品',
    // 9-19
    appGoldPriceAdjust: '淘金价调价申请单',
    originalPanningPrice: '原淘金价',
    cashRushPrice: '现淘金价',
    priceAdjustmentApplicationTime: '调价申请时间',
    priceAdjustmentNumber: '调价单号',
    supplyPriceAdjustmentListNumber: '供货价调价单号',
    AuditTime: '审核时间',
    auditStatus: '审核状态',
    auditor: '审核人',
    typePriceAdjustment: '调价类型',
    EffectiveTime: '生效时间',
    goldPriceAdjustOrderNumber: '淘金价调价单号',
    passivePriceAdjust: '被动调价',
    voluntaryPriceAdjust: '主动调价',
    platformServiceFee: '平台服务费',
    TalentAward: '达人奖励',
    priceAdjustmentInformation: '调价单信息',
    supplyPriceAdjustmentInformation: '供货价调价单信息',
    supplyPriceAdjustDetailsPanPriceSet: '供货价调价详情及淘金价设置',
    panningPriceSet: '淘金价设置',
    commoditiesPriceAdjust: '已调价的商品',
    productPicture: '商品图片',
    priceAdjustmentRatio: '调价比率'
  },
  //  开通品牌，店铺
  openBrandShop: {
    phone: '电话',
    AdministratorName: '管理员姓名',
    AdministratorPhone: '管理员电话',
    AdministratorEmail: '管理员邮箱',
    affidavitTime: '宣誓书到期时间',
    AboutExpire: '即将到期',
    ExpiredLicense: '证照过期',
    abnormal: '异常',
    SupplementaryInformation: '补充资料',
    uploadBanner: '上传banner图',
    AdministratorInformation: '管理员信息',
    mobile: '手机',
    MailingAddress: '邮寄地址',
    maximum30Characters: '最多不超过30个字符',
    openBrandShopTip1: '请填写店铺介绍，展示APP品牌店铺简介。注意：每月仅修改一次，请认真填写',
    SelectiveClassification: '选择分类',
    haveClassification: '选择分类',
    NewCategory: '新增分类',
    CauseRejection: '驳回原因',
    reEdit: '重新编辑',
    recertification: '重新认证',
    DataAuthentication: '资料认证',
    openBrandShopTip2: '请根据实际情况上传相关资料，您也可激活店铺后补充',
    BrandInformation: '品牌资料',
    BrandParty: '品牌方',
    JointVentureCompany: '合资公司',
    StateAgent: '国家代理',
    TrademarkApplication: '商标申请书',
    brandTrademarkAuthorization: '(品牌)商标授权书',
    TrademarkCertificate: '商标证书',
    CompanyInformation: '公司资料',
    SupportingMaterial: '证明材料',
    SignatureDirector: '董事签署',
    AuthorizedSignature: '授权签署',
    CertificateIncorporation: '公司登记证书',
    CompanyCertificateNumber: '公司登记证书号',
    // 10-14
    Limited30Characters: '限30个字符',
    companyAffidavit: '公司宣誓书',
    EffectiveCutoffTime: '有效截止时间',
    VATRegistrationCertificate: '增值税登记证',
    VATregistrationNumber: '增值税登记号码',
    openBrandShopTip3: '上传证照为：ภ.พ. 20 （新公司就提供ภ.พ.10）',
    DirectorPowerAttorney: '董事授权书',
    NameDirectorNameAuthorizRepresent: '董事名字，授权代表名字',
    ImmediateAuthentication: '立即认证',
    ApplicantInformation: '申请人信息',
    BrandOwnership: '品牌所有',
    RelatedWebsite: '相关网站',
    NameAuthoriRepresent: '董事名字、授权代表名字',
    goNext: '跳过',
    CertificationData: '认证资料',
    BrandStoreName: '品牌/店铺名称',
    AuditType: '审核类型',
    AddBalance: '添加余额',
    UserRegistrationCreationTime: '用户注册/创建时间',
    AcquisitionChannel: '获取通道',
    SubscriberMobilePhoneNumber: '用户手机号',
    userName: '用户姓名',
    firstPurchaseTime: '首单购买时间',
    WhetherRedEntryQualification: '是否有红包闯关资格',
    inviter: '邀请人',
    UserNickname: '用户昵称',
    OpenBetaInvitationCode: '公测邀请码',
    RedEnvelopeEntryInvitationCode: '红包闯关邀请码',
    ShareBuying: '分享购买',
    InvitationInvitationCode: '邀请函邀请码',
    RedEnvelopeQualificaManagement: '红包资格管理',
    RedEnvelopeQualificaManagement2: '红包闯关资格后台管理模块，运营还可以通过此模块手动给用户添加红包闯关资格',
    TotalOrderNumber: '总订单数',
    totalNumberPackages: '总件数',
    TotalAmountGoldPanningSales: '淘金销售总金额',
    TotalAmountRedPacketsMasterLevel: '达人层级红包总金额',
    TalentPromotionAward: '达人推广奖励',
    balanceTalentAccountRecorded: '达人账户余额入账',
    MasterGoldReward: '达人金币奖励',
    numberReturnedItems: '退货总件数',
    TotalAmountReturned: '退货总金额',
    bindingBankcardTip1: '绑定银行卡时需要选择银行卡对应的银行，该模块主要是在系统后台自定义添加银行信息',
    AddBank: '添加银行',
    BankAbbreviation: '银行简称',
    BankLogo: '银行Logo',
    lengthCannotExceed60Characters: '长度不超过60个字符',
    lengthCannotExceed20Characters: '长度不超过20个字符',
    PleaseFillBankAbbreviat: '请填写银行简称',
    PleaseFillBankLogo: '请填写银行Logo',
    LoginAccount: '登录账号',
    hongbaoEligibilityPeriod: '红包资格期限',
    addedRedPacketEntryQualificate: '添加红包闯关资格',
    ManualAddition: '手动添加',
    EligibilityPeriod: '资格有效期',
    QuantityAudited: '待审核数量',
    // 10-16
    WhetherSetUpLocalOperatCompany: '是否设立本地运营公司',
    copyTip1: '复制链接成功',
    englishOrNum: '只能为数字或英文',
    Num30: '不能超过30个字符',
    GoldRushSalesPaidOut: '淘金销售实付金额',
    // 10-23
    OnlyMP4FormatSupportedTips: '仅支持MP4格式，视频大小不可超过50M，建议视频尺寸为1080*1400或等比例为最佳',
    InvitationLetter1: '邀请函',
    InvitationLetter: '开启品牌自营',
    OpenBrandStore: '开通品牌店铺',
    ContactName: '联系人姓名',
    // 10-23下午
    copyTip2: '复制链接',

    picTips: '单张图片大小不超过3MB，最多上传5张，支持jpg、png、bmp格式',
    editNot: '编辑状态规格模板不可被编辑！',
    Not60String: '长度不超过 60 个字符',
    Not100String: '长度不超过 100 个字符',
    AudiComplete: '审核完成!',
    activeAuth: '活动审核',
    userAuth: '用户实名审核',
    shopBrandAuth: '品牌店铺审核',
    proAuth: '商品审核',
    SupplyPriceAdjustReview: '供货价调价审核',
    GoldRushPriceAdjustReview: '淘金价调价审核',
    BrandApplicatReview: '品牌申请审核',
    ServiceApplicatFollowUp: '服务申请跟进',
    EnterMultipleQueriesSequenceSeparatedCommas: '多个查询请逗号隔开依次输入',
    PleaseEnterEffectiveDate: '请输入生效日期',
    PleaseSelectProduct: '请选择商品！',
    PleaseFillCashPanPrice: '请填写现淘金价！',
    PleaseFillCashPanPriceTip2: '现淘金价必须大于现供货价，否则会造成资损！',
    PleaseFillCashPanPriceTip3: '淘金价调价申请成功！',
    PleaseFillCashPanPriceTip4: '商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准',
    PleasFillCurrentSupplyPrice: '请填写现供货价！',
    SupplyPriceAdjustApplicatSuccessful: '供货价调价申请成功',

    PleaseEnterCouponName: '请输入优惠券名称',
    PleaseEnterFaceValue: '请输入面值',
    PleaseSelectEventProduct: '请选择活动商品',
    numPerlimitTip2: '发放数量应大于等于',
    // 10-25
    ContactInformation: '联系人信息',
    BrandCategory: '品牌类目',
    RelevantData: '相关资料',
    ClickDownloadView: '下载简历',
    AdvertisingName: '广告名称',
    AdvertisingPosition: '广告位置',
    ActivityType: '活动类型',
    MaturityTime: '到期时间',
    OnlineOffline: '上线/下线',
    downline: '下线',
    TopLine: '上线',
    AdvertisingPicture: '广告图片',
    AdvertisingLink: '广告链接',
    AdvertisementNote: '广告备注',
    PleaseEnterContent: '请输入内容',
    PCHomePageRotation: 'PC首页轮播',
    APPHomeCarousel: 'APP首页轮播',
    AddAnAD: '添加广告',
    PleaseEnterADName: '请输入广告名称',
    PleaseEnterADLink: '请输入广告链接',
    PleaseSelectStartTime: '请选择开始时间',
    PleaseSelectExpirationTime: '请选择到期时间',
    PleaseSelectAdvertiseImage: '请选择广告图片',
    GeneralAdvertise: '普通广告',
    ActivityAdvertise: '活动广告',
    VerificationFailure: '验证失败',
    time: '时间',
    clickTime: '点击次数',
    GenerateOrder: '生成订单',
    MxcomeText1: '我已阅读并同意',
    MxcomeText2: '《MXCOME商家服务协议》',
    MxcomeText3: '申请成为MXCOME官方店铺的商家',
    // 10-26
    PleaseEnterAccountNumber: '请输入账号',
    PleaseEnterPassword: '请输入密码',
    AccountNumberName: '帐号/姓名',
    ServiceType: '服务类型',
    FillMobilePhoneNumberMasterRegistrate: '填写达人注册的手机号',
    EnglishNumberMaximum30Characters: '英文、数字、英文+数字，最多不超过30个字符',
    memberPhone: '达人手机号',
    inputMemberPhone: '请输入达人手机号',
    Up60Characters: '最多60个字符',
    EditSaveSuccess: '编辑保存成功！',
    PleaseSelectStoreFirstProceedOperation: '请先选择店铺后，再进行操作！',
    WhetherDeleteBank: '是否要删除该银行?',
    delSuccess: '删除成功！',
    editBank: '编辑银行',
    ServiceName: '服务名称',
    AuditDetails: '审核详情',
    HaveEntered: '是否已入驻',
    numPerlimitTip: '发放数量和每天限兑需大于等于1的正整数！',
    numPerlimitTip3: '商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准',

    // 10-27
    inputCode: '请输入验证码！',
    choseIDcardValidate: '请选择身份证有效期',
    applicationSuccess: '申请成功！',
    LevelsMustConsecutive2Level: '关卡要连续且不能小于两关！',
    endDateGreaterStartDate: '结束日期要大于开始日期！',
    endDate7DaysOlderStartDate: '结束日期不能大于开始日期超过7天！',
    taskProdect13spu: '任务商品每关只能有1-3个spu商品！',
    taskProductStock: '任务商品库存不能为空！',
    pleaseChoseNumber: '请选择排名奖励',
    numberPriceOrStockNull: '排名奖励价格或赠品库存为空',
    numberStartNEndNull: '排名奖励开始名次或结束名次为空！',
    numberPriceBigEndStart: '排名奖励库存需要大于结束名次与开始名次之差！',
    // 10-28
    innerBox: '内部',
    NetRedEnvelopeEntryThreeValue: '网红达人红包闯关资格三关总价值',
    FillOutSeveralTimes: '分几次提现',
    times: '次',
    numberTimesMustEqualAmountBonus: '次数必须能被奖励红包金额整除',
    PleaseFillLogisticsCompanyCode: '请填写物流公司Code',
    PleaseFillLogoLogisticsCompany: '请填写有物流公司Logo',
    SoldOut: '已售磬',
    DoDeleteLogisticsCompany: '是否要删除该物流公司?',
    cumulativeSalesIntegerGreaterEqual: '累计销量需为大于等于0的整数！',
    EditorialLogisticsCompany: '编辑物流公司',
    SetArea: '设置地区',
    volume: '体积',
    VolumeAmount: '体积+金额',
    AreWantDeleteSettingsCurrentRegion: '确认要删除当前地区的设置吗？',
    BrandProfileChange: '品牌简介更改',
    StoreProfileChange: '店铺简介更改',
    CertificationDataSupplement: '认证资料补充',
    FailAudit: '审核未通过',
    inventoryQuantityNoExceed: '库存数量不能超过',

    // 11-1
    ViewExamples: '查看示例',
    certificateInformatSubmitSuccess: '认证资料提交成功，将在48小时内审核完毕，审核通过后，才能上架商品！',
    toDoThisDelete: '是否要进行该删除操作?',
    activatStoreAuthenticatInformatSuccessfulSubmit: '激活店铺认证信息提交成功，将在48小时内审核完毕，审核通过后，才能创建商品！',
    activatStoreAuthenticatInformatSuccessfulSubmit2: '为了更好地保障您的合法权益，请阅读以下协议:',
    brandInfoAgain: '品牌简介重新认证提交成功，将在48小时内审核完毕！',
    brandInfoAgain2: '宣誓书到期前，需要在【补充资料】更新宣誓书，否则所有商品会全部下架无法正常销售！',
    home: '首页',
    quit: '退出',
    CloseOther: '关闭其他',
    CloseAll: '关闭所有',
    AlreadyEnter: '已入驻',
    NotYetEnter: '未入驻',
    corporateServices: '企业服务',
    OperationService: '运营服务',
    package: '包裹',
    selfSupport: '自营',
    BatchImport: '批量导入',
    DownloadTemplate: '下载模板',
    ToLeadInto: '导入',
    ImportList: '导入名单',
    CouponCodeInformat: '券码信息',
    zhangCan: '张可用',
    // 11-2
    NewFirstLevelClassificat: '新增一级分类',
    EditPrimaryClassifica: '编辑一级分类',
    EditPrimaryClassifica2: '编辑二级分类',
    EditFirstClassificatGoods: '编辑商品一级分类',
    EditCommoditSecondaryClassificat: '编辑商品二级分类',
    CategoryNamecn: '分类名称(cn)',
    CategoryNameen: '分类名称(en)',
    CategoryNameth: '分类名称(th)',
    PrimaryClassificatCommoditiesCn: '商品一级分类(cn)：',
    PrimaryClassificatCommoditiesEn: '商品一级分类(en)：',
    PrimaryClassificatCommoditiesTh: '商品一级分类(th)：',
    guigeData: '规格数据',
    guigeName: '规格名称',
    choseList: '可选列表',
    addNewParam: '新增参数',
    addNewGuige: '新增规格',
    // 11-3
    ManualInput: '手动输入',
    SelectBox: '选择框',
    PleaseSelectRegion: '请选择要批量处理的地区！',
    TicketCodeNumber: '券码号',
    AlreadyExist: '已存在',
    needDeleteDataImportTemplateImportAgain: '需要在导入模板删除该数据后重新导入',
    NetRedTalentRedEnvelopeCrosTask: '网红达人红包闯关任务设置',
    // 11-9
    activatStoreAuthenticatInformatSuccessfulSubmit2: '为了更好地保障您的合法权益，请阅读并同意以下协议:',
    PleaseEnterYourName: '请输入姓名',
    PleaseEnterYourContactEmail: '请输入联系邮箱',
    congeniality: '同 意',
    PleaseUploadStoreLogo: '请上传店铺logo',
    PleaseFillFullAddress: '请填写详细地址',
    PleaseFillLeastOneField: '请至少填写一项内容后再提交，否则请点跳过！',
    PleaseFillTheCategory: '请填写分类！',
    DuplicateBrandName: '品牌名称重复！',
    PleaseSelectCategory: '请选择分类',
    PleaseFillMailAddressCareful: '请认真填写邮寄地址！',
    // 11-10
    PleaseEnterActivityName: '请输入活动名称',
    PleaseEnterActivitySubtitle: '请输入活动副标题',
    lengthBetween140Characters: '长度在 4 到 140 个字符',
    // 11-15
    FeedbackPerson: '反馈人',
    FeedbackTime: '反馈时间',
    FeedbackType: '反馈类型',
    source: '来源',
    ImprovementSuggest: '改进建议',
    Off: '关闭',
    SupplyPriceAdjustRequestSubmit: '供货价调价申请单提交成功',
    PleaseEnterTemplateName: '请输入模板名称',
    PleaseSelectShipAddress: '请选择发货地址',
    AreWantDeleteSetCurrentRegion: '确认要删除当前地区的设置么？',
    MerchandiseReconciliaState: '商品对账表',
    SalesStatement: '销售报表',
    InventoryWarning: '库存预警',
    InventoryInquiryReport: '库存查询报表',
    AfterSalePendingReview: '售后待审核',
    Limited60Characters: '限60个字符',
    InteractiveSuggest: '交互建议',
    FunctionalSuggest: '功能建议',
    BUGSubmission: 'BUG提交',
    others: '其他',
    ProductsMeetConditionsRemove: '商品不符合下架条件，不能被下架!',
    BowWeight: '首重量(kg)',
    BowV: '首体积(m³)',
    BowWSecond: '续重量(kg)',
    BowVSecond: '续体积(m³)',
    RedEnvelopeEntryTaskName: '红包闯关任务名称',
    EligibilityPeriodMandatory: '资格有效期为必填项',
    Cleared: '已通关',
    recoveredAfterBeingDeleted: '删除后，数据无法恢复，请谨慎操作！',
    AgreeRefund: '同意退款',
    CloseOrder: '关闭订单',
    sureAgreeRefund: '确定同意退款？',
    RefundSuccessful: '退款成功！',
    //  12-1
    ScheduleVisit: '预约来访时间',
    MakeSureFollowService: '确定已经跟进该项服务！',
    FollowUpComplete: '跟进完成！',
    WebNet: '官网',
    read: '已读',
    readNot: '未读',
    CreateEditTime: '创建/编辑时间',
    AddTask: '添加任务',
    nameSuper: '名称',
    choseTask: '选择任务',
    SelectedTask: '已选任务',
    CommodityType: '商品类型',
    PackageGoods: '套餐商品',
    GeneralMerchandise: '普通商品',
    EditingTask: '编辑任务',
    // 12-4
    welcome: '欢迎',
    WelcomeMXCOMEMerchantOperationConsole: '欢迎来到MXCOME商家运营控制台',
    ActivateBrandedStore: '激活您的品牌店铺',
    ProvidePutGoodsShelves: '提供完整的认证资料，审核通过后，即可上架商品',
    ActivateNow: '立即激活',
    BrandStoreReviewed: '品牌店铺开通待审核',
    openingInformationBrandStore: '品牌店铺开通资料已提交，将在48小时内审核完成，待审核通过后，即可上架商品',
    setWarehousAddress: '设置仓库地址',
    setShipTemplates: '设置运费模板',
    AddBrandStores: '增设品牌店铺',

    BrandManage: '品牌管理',
    ShopManage: '店铺管理',
    proManage: '商品管理',
    taskManage: '任务管理',
    activeManage: '活动管理',
    orderManage: '订单管理',
    // 12-13
    MerchantName: '商家名称',
    AreListItem: '确定上架该商品？',
    AreRemovePro: '确定下架该商品？',
    AreReviewPro: '确定重新审核该商品？',
    AreDelPro: '确定删除该商品？',
    copyrightAuthorizaMng: '版权授权申请管理',
    ClickDownloadView: '点击下载查看',
    PleaseSelectExpiratDate: '请选择失效日期',
    EnglishNumberMaximum10Characters: '英文、数字、英文+数字，最多不超过10个字符',
    Num10: '不能超过10个字符',
    FollowUpStatus: '跟进状态',
    republish: '再次发布',
    uploadedVideoCannotEmpty: '上传视频不能为空!',
    salaryRangePositiveInteger: '薪资区间需为正整数',
    pleaseInputEnglish: '请输入英文',
    promoterRegisterMobileNumber: '请输入推广人注册手机号',
    PleaseSelectStartDate: '请选择开始日期',
    PleaseSelectEndDate: '请选择结束日期',
    alliance: '联盟',
    NoDoubleDigits: '不能超过两位数',
    No3Digits: '不能超过三位数',
    innerCode: '内部邀请码',
    // 12-18
    PromoterNickname: '请输入推广人昵称',
    noMore50string: '不能超过50个字符',
    lianceCode: '联盟邀请码',
    thai: '泰国',
    china: '中国',
    salaryRangePositiveInteger2: '薪资区间需为正数',
    idcardNum2: '身份证/护照号码',
    DeleteVideo: '删除视频',
    VideoDeletionSuccessful: '视频删除成功!',
    promoterRegisterMobileNumber: '推广人注册手机号',
    registerMobilePhoneNumber: '填写注册的手机号',
    PromoterNickname2: '推广人昵称',
    promoterNicknameEnglishOnly: '填写推广人的姓名或昵称，只能输入英文',
    AuthorizationType: '授权类型',
    ApplicationType: '申请类型',
    articleReprint: '文章转载',
    ContenReference: '内容引用',
    copyrightLicenseApplicationDetails: '版权授权申请详情',
    requirement: '需求',
    FollowSuccessful: '跟进成功',
    influencerJoinApplicatDetails: '网红加入申请详情',
    screenshotDayChannel: '当日频道截图',
    ReleaseTime: '发布时间',
    Base: 'Base地',
    RecruitmentDepartment: '招聘部门',
    JobTitle: '岗位名称',
    DeliveryTime: '投递时间',
    NatureWork: '工作性质',
    ContactLocation: '联系人所在地区',
    EducationalRequire: '学历要求',
    fullTime: '全职',
    PartTimeJob: '兼职',
    practice: '实习',
    PostReleaseTime: '岗位发布时间',
    viewResume: '查看简历',
    PostJobRequirements: '发布岗位需求',
    JobExperience: '岗位经验',
    YearsMore: '年以上',
    SalaryRange: '薪资区间',
    JobDescription: '岗位描述',
    FailureTime: '失效时间',
    // 12-21
    curriculumVitae: '简历',
    JuniorCollege: '大专',
    SeniorHighSchool: '高中',
    UndergraduateCourse: '本科',
    master: '硕士',
    LearnedScholar: '博士',
    PleaseSelectBasePlace: '请选择Base地',
    PleaseRecruitmentDepartment: '请输入招聘部门',
    PleaseSelectExpirationTime: '请选择失效时间',
    PleaseEnterJobExperience: '请输入岗位经验',
    PleaseEnterJobDescription: '请输入岗位描述',
    PleaseSelectJobType: '请选择工作性质',
    PleaseEnterJobTitle: '请输入岗位名称',
    PleaseEnterSalaryRange: '请输入薪资区间',
    PleaseSelectEducationalRequirements: '请选择学历要求',

    // 12-22
    promoterNicknameEnglishNumberOnly: '填写推广人的姓名或昵称，只能输入英文、数字、英文+数字',
    noVideoProduct: '该商品暂无视频',
    //  12-26
    MerchantWithdrawalFeeSetting: '商家提现手续费:',

    RedEnvelopeEntryQualificatDeadline: '红包闯关资格截止日期',
    overdueQualificatInvalidRedEnvelopeReward: '逾期资格失效，不再获得红包奖励',
    totalEligibilityPeriod: '资格有效期共计',

    netRedTalentTaskSet: '网红达人闯关任务设置',
    GoldRushTalenRedEnvelope: '淘金达人红包闯关',
    InternetCelebrityTalentRedEnvelope: '网红达人红包闯关',
    netRedTalentRedEnvelopCrossActivityLevelSet: '网红达人红包闯关活动关卡设置',
    netCelebrityRedEnvelopeQualificatValidPeriod: '网红达人红包闯关资格有效期限',

    redEnvelopeEligibilityValidityPeriod: '红包资格有效期限',
    addedRedEnvelopeQuest: '添加红包闯关任务',
    startTime: '起始时间',

    NoRelevantInformationUploaded: '未上传相关资料',
    certificationSupplementaryMaterialsSubmittedSuccessful: '认证信息补充资料提交成功，将在48小时内审核完毕，审核通过后，才能上架商品！',



    // 1.6版本 新加
    AddBankAccount: '添加银行账户',
    BindingType: '绑定类型',
    BankAccountName: '银行账户名称',
    BankDeposit: '开户银行',
    PassbookAccount: '存折账号',
    PassbookPhoto: '存折照片',

    // 1-2
    title: '标题',
    Normal: '普通',
    keyPoint: '重点',
    post: '发布岗位',
    readPeople: '阅读人数',
    amountSingleGiftGoldCoins: '单次赠送金币金额',
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins: '已赠送金币金额',
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins2: '赠送金币金额',

    //  1-3
    effectiveTime: '有效时间',
    post: '发布岗位',
    confirmDeleteData: '确定删除这条数据?',
    pushCrowd: '推送人群:',


    skuCodeNum: 'SKU编号',
    adjustmentOrderNumber: '调整单号',
    documentsAdjustmentShareRatio: '分润比例调整单据',
    effectiveStartTime: '生效起始时间',
    effectiveEndTime: '生效结束时间',
    adjustQuantityGoods: '调整商品数量',
    proportDistributAdjusted: '分润比例调整',

    activationTaskTime: '激活任务时间',
    nickNameRedPackage: '昵称',
    registrationTime: '注册时间',
    userType: '用户类型',
    registeredMobileNumber: '注册手机号',
    inviter: '邀请人',
    nameWorldStar: '环球星达人姓名',
    ringStarNumber: '环球星达人电话',
    totalVisitors: '总访客数',
    numberFans: '粉丝数',
    purchaser: '购买人',
    purchaserPhone: '购买人手机号',
    productNum: '商品数量',
    goldRushAmount: '淘金金额',
    amountPaidOrder: '订单需付金额',
    actualAmountPaid: '实际付款金额',
    actualGold: '实际付款金币',
    orderCompletTime: '订单完成时间',

    // 1.6版本 新加 - 银行卡
    AddBankAccount: '添加银行账户',
    BindingType: '绑定类型',
    BankAccountName: '银行账户名称',
    BankDeposit: '开户银行',
    PassbookAccount: '存折账号',
    PassbookPhoto: '存折照片',
    // 2-4
    adjustmentOrderNumber: '调整单号',
    documentsAdjustmentShareRatio: '分润比例调整单据',
    effectiveStartTime: '生效起始时间',
    effectiveEndTime: '生效结束时间',
    adjustQuantityGoods: '调整商品数量',
    proportDistributAdjusted: '分润比例调整',

    passiveTaskOrder: '被动任务订单',
    sunOrderNum: '子订单号',
    masterOrderNumber: '母订单号',
    headDevPurRecords: '团长发展购买记录',
    leaderDevReport: '团长发展体系报表',
    performanceStatisticsPeriod: '业绩统计期',
    bondUpperLowerTiers: '上下级绑定时间',
    upperPhone: '上级手机号',
    upperNickName: '上级昵称',
    userRegistraTime: '用户注册时间',
    buyPhoneNumber: '购买人手机号',
    NumberItems: '商品件数',
    upper: '上级',
    goldRushAmount: '淘金金额',
    NumberSubordinates: '下级人数',
    IOrderPeriod: '本人本期单量',
    nextOrderPeriod: '下级本期单量',
    totalOrdersPeriod: '本期总单量',
    currentSalesAmount: '本期销售金额',
    periodExpectedPromoteIncentives: '本期预计推广奖励',
    amountRecordePeriod: '本期已入账金额',
    numberReturnedItemsPeriod: '本期退货总件数',
    amountReturnedPeriod: '本期退货金额',
    accumulatedSingleQuantity: '本人累计单量',
    orderCumulativeSingleQuantity: '下级累计单量',
    totalCumulativeSingleQuantity: '累计总单量',
    cumulativeSalesAmount: '累计销售金额',
    amountEstimatedPromotionIncentives: '累计预计推广奖励总金额',
    cumulativeAmountCredited: '累计已入账金额',
    channelSalesServiceFeeSet: '渠道销售服务费设置',
    shopLabel: '店铺标签',
    addStoreLabelItems: '添加店铺标签商品',
    contentRecommendedUploadVideoSet: '内容推荐上传视频设置',
    visitorVolumSetting: '访客量设置',
    addContent: '添加内容',
    definitiveDel: '确定删除?',
    createDisappear: '创建消息',
    messageName: '消息名称',
    messageContent: '消息内容',
    platformNotification: '平台通知',
    infoType: '消息类型',
    infoTitle: '消息标题',
    pushNotification: '推送',
    originalPlatformServiceCharge: '原平台服务费',
    primaryProportion: '原占比',
    adjustRatio: '调整比例(%)',
    currentPlatformServiceFee: '现平台服务费(฿)',
    originalTalentAward: '原达人奖励',
    talentAward: '现达人奖励',
    goldCoinsRedEnvelopeSet2: '金币兑红包设置(红包闯关第二季)',
    goldCoinsRedEnvelopeSetInstructions: '设置金币兑红包有效期限，逾期金币兑红包的兑换入口关闭',
    ConversionRatio: '兑换比例',
    goldCoin: '金币',
    defaultGoldCoin4Baht: '兑换比例为空时，默认1金币 = 4铢',
    goldRedEnvelopeLevelSet: '金币红包关卡设置',
    goldExchange: '兑换金币',
    emptySystemDefaultsGoldCoins: '兑换金币值为空，系统默认兑换金币为',
    limitedQuantity: '限兑数量',
    limitedQuantityNum: '限兑数量为每关兑换数量，兑完即止。为空即为不限量，系统默认数量为',
    taskOrderNumber: '任务单号',
    goldExchange2: '金币兑换',
    goldDigger: '淘金达人',
    goldDigger2: '环球星达人',
    setRate: '设置费率',
    setChannelServiceFeeRate: '设置渠道销售服务费费率',
    channelServiceFeeRate: '渠道销售服务费费率',
    levelId: '类目ID',
    successSetRate: '设置费率成功！',
    netRedGoodPeople: '网红达人',
    talentSpaceVisitsReached: '环球星达人空间访问量达到',
    talentSpaceVisitsReached2: '空间内容推荐自主上传视频入口开放，可自主上传视频',
    talentSpaceVisitsReached3: '淘金达人空间访问量达到',
    productLabel: '商品标签',
    distriRatioAdjustSheetInformat: '分润比例调整单信息',
    distriRatioAdjustSet: '分润调整设置',
    adjustedGoods: '已调整的商品',

    // 1.6版本 新加 - 银行卡
    AddBankAccount: '添加银行账户',
    BindingType: '绑定类型',
    BankAccountName: '银行账户名称',
    BankDeposit: '开户银行',
    PassbookAccount: '存折账号',
    PassbookPhoto: '存折照片',

    auditor: '审核人员',
    headSysSetup: '团长发展体系设置',
    headSystem: '团长发展体系',
    headSystemTip: '（默认开启状态，提示：该开关涉及APP消费返利及页面展示、运营后台团长发展体系报表、购买记录等功能）',

    distriRatioAdjustSheetInformat: '分润比例调整单信息',
    distriRatioAdjustSet: '分润调整设置',
    adjustedGoods: '已调整的商品',

    originalPlatformServiceCharge: '原平台服务费',
    primaryProportion: '原占比',
    adjustRatio: '调整比例(%)',
    currentPlatformServiceFee: '现平台服务费(฿)',
    originalTalentAward: '原达人奖励',
    talentAward: '现达人奖励',
    ConversionRatio: '兑换比例',
    AdjustmentOrderNumber: '调整单号',
    totalAmountCurrent: '当前账户总金额',
    adjustmentRatioCannotEmptyTip: '调整比例和现平台服务费不能为空！',
    EnteringIncorrectInformationResultTransactionTip: '输入不正确的信息将导致交易被拒绝，并且您将承担处理您的请求相关的任何费用',

    counted: '待统计',
    counted2: '待结算',
    counted3: '已结算',
    bankNotNullTip: '请上传存折照片！',

    bankPleaseInputNameTip: '请输入银行账户名称！',
    bankPleaseInputIDCardTip: '请输入存折账号！',
    goBackNum: '退货件数',
    goBackMoney: '退货金额',
    notFix: '不结算',

    serviceNumIsLong: '服务单号不能超过8位！',
    corporateBankAccount: '公司银行账户',
    PurchasePersonNot: '是否本人购买',
    settlementStatus: '结算状态',
    settlementStatus1: '待结算',

    shipTemplateNot10: '运费模板不能超过10条！',
    taskStatus: '任务状态',
    canceled: '已取消',

    balancePayment: '余额支付',
    mixedPayment: '混合支付',
    QRPayment: 'QR支付',
    mbankingPayment: 'mbanking支付',

    storeProfileCertificated: '店铺简介重新认证提交成功，将在48小时内审核完毕！',
    pleaseSelectProtype: '请选择商品类型',

    more10Min: '开始日期需要大于当前时间10分钟后！',
    newCategoryDuplicate: '新增分类重复',
    addShopLabelPro: '添加店铺标签及商品',

    invitedUsersorNot: '是否受邀用户',
    talentSpaceVisitsReachedNotNull: '环球星达人空间访问量不能为空！',

    pusSuccess: '推送成功！',
    inputTitleName: '请输入标题名称',
    // totalAmountCurrent: '当前账户总金额'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js